import { render, staticRenderFns } from "./trainModal.vue?vue&type=template&id=49f559b6&scoped=true"
import script from "./trainModal.vue?vue&type=script&lang=js"
export * from "./trainModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f559b6",
  null
  
)

export default component.exports